import { render, staticRenderFns } from "./BlogPage.vue?vue&type=template&id=0b7f1cfc&"
import script from "./BlogPage.vue?vue&type=script&lang=js&"
export * from "./BlogPage.vue?vue&type=script&lang=js&"
import style0 from "./BlogPage.vue?vue&type=style&index=0&id=0b7f1cfc&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports